import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCart = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	height: 35,
	viewBox: "0 0 426.667 426.667",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "current",
		d: "M128 341.333c-23.573 0-42.453 19.093-42.453 42.667s18.88 42.667 42.453 42.667 42.667-19.093 42.667-42.667-19.094-42.667-42.667-42.667m213.333 0c-23.573 0-42.453 19.093-42.453 42.667s18.88 42.667 42.453 42.667S384 407.573 384 384s-19.093-42.667-42.667-42.667M151.467 234.667H310.4c16 0 29.973-8.853 37.333-21.973L424 74.24c1.707-2.987 2.667-6.507 2.667-10.24 0-11.84-9.6-21.333-21.333-21.333H89.92L69.653 0H0v42.667h42.667L119.36 204.48l-28.8 52.267c-3.307 6.187-5.227 13.12-5.227 20.587C85.333 300.907 104.427 320 128 320h256v-42.667H137.067c-2.987 0-5.333-2.347-5.333-5.333q0-1.44.64-2.56z"
	})
});
export default SvgCart;
